/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteRouteImport } from './routes/terms/route'
import { Route as PrivacyPolicyRouteRouteImport } from './routes/privacy-policy/route'
import { Route as LoginRouteRouteImport } from './routes/login/route'
import { Route as InviteRouteRouteImport } from './routes/invite/route'
import { Route as GetAppRouteRouteImport } from './routes/get-app/route'
import { Route as ChildSafetyRouteRouteImport } from './routes/child-safety/route'
import { Route as ProtectedRouteRouteImport } from './routes/_protected/route'
import { Route as OauthCallbackRouteRouteImport } from './routes/oauth/callback/route'
import { Route as InternalTestPlayalertRouteRouteImport } from './routes/internal/test-playalert/route'
import { Route as InternalLoginRouteRouteImport } from './routes/internal/login/route'
import { Route as ProtectedOnboardingRouteRouteImport } from './routes/_protected/onboarding/route'
import { Route as ProtectedAppRouteRouteImport } from './routes/_protected/_app/route'
import { Route as ProtectedOnboardingIndexRouteImport } from './routes/_protected/onboarding/index'
import { Route as ProtectedOnboardingStepsRouteRouteImport } from './routes/_protected/onboarding/_steps/route'
import { Route as ProtectedAppMainLayoutRouteRouteImport } from './routes/_protected/_app/_mainLayout/route'
import { Route as ProtectedAppMainLayoutIndexRouteImport } from './routes/_protected/_app/_mainLayout/index'
import { Route as ProtectedOnboardingStepsVoiceChatParticipationRouteRouteImport } from './routes/_protected/onboarding/_steps/voice-chat-participation/route'
import { Route as ProtectedOnboardingStepsStatsRouteRouteImport } from './routes/_protected/onboarding/_steps/stats/route'
import { Route as ProtectedOnboardingStepsServersRouteRouteImport } from './routes/_protected/onboarding/_steps/servers/route'
import { Route as ProtectedOnboardingStepsPreGameRoutineRouteRouteImport } from './routes/_protected/onboarding/_steps/pre-game-routine/route'
import { Route as ProtectedOnboardingStepsPlayScheduleRouteRouteImport } from './routes/_protected/onboarding/_steps/play-schedule/route'
import { Route as ProtectedOnboardingStepsPersonalityTraitsRouteRouteImport } from './routes/_protected/onboarding/_steps/personality-traits/route'
import { Route as ProtectedOnboardingStepsNotificationsRouteRouteImport } from './routes/_protected/onboarding/_steps/notifications/route'
import { Route as ProtectedOnboardingStepsNonToxicRouteRouteImport } from './routes/_protected/onboarding/_steps/non-toxic/route'
import { Route as ProtectedOnboardingStepsNearlyDoneRouteRouteImport } from './routes/_protected/onboarding/_steps/nearly-done/route'
import { Route as ProtectedOnboardingStepsModeSelectionRouteRouteImport } from './routes/_protected/onboarding/_steps/mode-selection/route'
import { Route as ProtectedOnboardingStepsLanguagesRouteRouteImport } from './routes/_protected/onboarding/_steps/languages/route'
import { Route as ProtectedOnboardingStepsInGameCommStyleRouteRouteImport } from './routes/_protected/onboarding/_steps/in-game-comm-style/route'
import { Route as ProtectedOnboardingStepsGameModePreferenceRouteRouteImport } from './routes/_protected/onboarding/_steps/game-mode-preference/route'
import { Route as ProtectedOnboardingStepsFavouriteAgentRouteRouteImport } from './routes/_protected/onboarding/_steps/favourite-agent/route'
import { Route as ProtectedOnboardingStepsDisplayNameRouteRouteImport } from './routes/_protected/onboarding/_steps/display-name/route'
import { Route as ProtectedOnboardingStepsBondingPaceRouteRouteImport } from './routes/_protected/onboarding/_steps/bonding-pace/route'
import { Route as ProtectedOnboardingStepsAgeRouteRouteImport } from './routes/_protected/onboarding/_steps/age/route'
import { Route as ProtectedOnboardingStepsSplatRouteRouteImport } from './routes/_protected/onboarding/_steps/$/route'
import { Route as ProtectedAppMainLayoutFiltersRouteRouteImport } from './routes/_protected/_app/_mainLayout/filters/route'
import { Route as ProtectedAppMainLayoutDuoChatsRouteRouteImport } from './routes/_protected/_app/_mainLayout/duo-chats/route'
import { Route as ProtectedAppMainLayoutMyDuosIndexRouteImport } from './routes/_protected/_app/_mainLayout/my-duos/index'
import { Route as ProtectedAppMainLayoutMeIndexRouteImport } from './routes/_protected/_app/_mainLayout/me/index'
import { Route as ProtectedAppMainLayoutLikesIndexRouteImport } from './routes/_protected/_app/_mainLayout/likes/index'
import { Route as ProtectedAppMainLayoutProfilesMeRouteRouteImport } from './routes/_protected/_app/_mainLayout/profiles/me/route'
import { Route as ProtectedAppMainLayoutProfilesProfileIdRouteRouteImport } from './routes/_protected/_app/_mainLayout/profiles/$profileId/route'
import { Route as ProtectedAppMainLayoutMyDuosIdRouteRouteImport } from './routes/_protected/_app/_mainLayout/my-duos/$id/route'
import { Route as ProtectedAppMainLayoutMeSettingsRouteRouteImport } from './routes/_protected/_app/_mainLayout/me/settings/route'
import { Route as ProtectedAppMainLayoutMeEditRouteRouteImport } from './routes/_protected/_app/_mainLayout/me/edit/route'
import { Route as ProtectedAppMainLayoutLikesIdRouteRouteImport } from './routes/_protected/_app/_mainLayout/likes/$id/route'
import { Route as ProtectedAppMainLayoutDuoChatsDuoIdRouteRouteImport } from './routes/_protected/_app/_mainLayout/duo-chats/$duoId/route'

const TermsRouteRoute = TermsRouteRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRouteRoute = PrivacyPolicyRouteRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRouteRoute = LoginRouteRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRouteRoute = InviteRouteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const GetAppRouteRoute = GetAppRouteRouteImport.update({
  id: '/get-app',
  path: '/get-app',
  getParentRoute: () => rootRouteImport,
} as any)
const ChildSafetyRouteRoute = ChildSafetyRouteRouteImport.update({
  id: '/child-safety',
  path: '/child-safety',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRouteRoute = ProtectedRouteRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthCallbackRouteRoute = OauthCallbackRouteRouteImport.update({
  id: '/oauth/callback',
  path: '/oauth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const InternalTestPlayalertRouteRoute =
  InternalTestPlayalertRouteRouteImport.update({
    id: '/internal/test-playalert',
    path: '/internal/test-playalert',
    getParentRoute: () => rootRouteImport,
  } as any)
const InternalLoginRouteRoute = InternalLoginRouteRouteImport.update({
  id: '/internal/login',
  path: '/internal/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedOnboardingRouteRoute =
  ProtectedOnboardingRouteRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedAppRouteRoute = ProtectedAppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedOnboardingIndexRoute =
  ProtectedOnboardingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedOnboardingRouteRoute,
  } as any)
const ProtectedOnboardingStepsRouteRoute =
  ProtectedOnboardingStepsRouteRouteImport.update({
    id: '/_steps',
    getParentRoute: () => ProtectedOnboardingRouteRoute,
  } as any)
const ProtectedAppMainLayoutRouteRoute =
  ProtectedAppMainLayoutRouteRouteImport.update({
    id: '/_mainLayout',
    getParentRoute: () => ProtectedAppRouteRoute,
  } as any)
const ProtectedAppMainLayoutIndexRoute =
  ProtectedAppMainLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedAppMainLayoutRouteRoute,
  } as any)
const ProtectedOnboardingStepsVoiceChatParticipationRouteRoute =
  ProtectedOnboardingStepsVoiceChatParticipationRouteRouteImport.update({
    id: '/voice-chat-participation',
    path: '/voice-chat-participation',
    getParentRoute: () => ProtectedOnboardingStepsRouteRoute,
  } as any)
const ProtectedOnboardingStepsStatsRouteRoute =
  ProtectedOnboardingStepsStatsRouteRouteImport.update({
    id: '/stats',
    path: '/stats',
    getParentRoute: () => ProtectedOnboardingStepsRouteRoute,
  } as any)
const ProtectedOnboardingStepsServersRouteRoute =
  ProtectedOnboardingStepsServersRouteRouteImport.update({
    id: '/servers',
    path: '/servers',
    getParentRoute: () => ProtectedOnboardingStepsRouteRoute,
  } as any)
const ProtectedOnboardingStepsPreGameRoutineRouteRoute =
  ProtectedOnboardingStepsPreGameRoutineRouteRouteImport.update({
    id: '/pre-game-routine',
    path: '/pre-game-routine',
    getParentRoute: () => ProtectedOnboardingStepsRouteRoute,
  } as any)
const ProtectedOnboardingStepsPlayScheduleRouteRoute =
  ProtectedOnboardingStepsPlayScheduleRouteRouteImport.update({
    id: '/play-schedule',
    path: '/play-schedule',
    getParentRoute: () => ProtectedOnboardingStepsRouteRoute,
  } as any)
const ProtectedOnboardingStepsPersonalityTraitsRouteRoute =
  ProtectedOnboardingStepsPersonalityTraitsRouteRouteImport.update({
    id: '/personality-traits',
    path: '/personality-traits',
    getParentRoute: () => ProtectedOnboardingStepsRouteRoute,
  } as any)
const ProtectedOnboardingStepsNotificationsRouteRoute =
  ProtectedOnboardingStepsNotificationsRouteRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => ProtectedOnboardingStepsRouteRoute,
  } as any)
const ProtectedOnboardingStepsNonToxicRouteRoute =
  ProtectedOnboardingStepsNonToxicRouteRouteImport.update({
    id: '/non-toxic',
    path: '/non-toxic',
    getParentRoute: () => ProtectedOnboardingStepsRouteRoute,
  } as any)
const ProtectedOnboardingStepsNearlyDoneRouteRoute =
  ProtectedOnboardingStepsNearlyDoneRouteRouteImport.update({
    id: '/nearly-done',
    path: '/nearly-done',
    getParentRoute: () => ProtectedOnboardingStepsRouteRoute,
  } as any)
const ProtectedOnboardingStepsModeSelectionRouteRoute =
  ProtectedOnboardingStepsModeSelectionRouteRouteImport.update({
    id: '/mode-selection',
    path: '/mode-selection',
    getParentRoute: () => ProtectedOnboardingStepsRouteRoute,
  } as any)
const ProtectedOnboardingStepsLanguagesRouteRoute =
  ProtectedOnboardingStepsLanguagesRouteRouteImport.update({
    id: '/languages',
    path: '/languages',
    getParentRoute: () => ProtectedOnboardingStepsRouteRoute,
  } as any)
const ProtectedOnboardingStepsInGameCommStyleRouteRoute =
  ProtectedOnboardingStepsInGameCommStyleRouteRouteImport.update({
    id: '/in-game-comm-style',
    path: '/in-game-comm-style',
    getParentRoute: () => ProtectedOnboardingStepsRouteRoute,
  } as any)
const ProtectedOnboardingStepsGameModePreferenceRouteRoute =
  ProtectedOnboardingStepsGameModePreferenceRouteRouteImport.update({
    id: '/game-mode-preference',
    path: '/game-mode-preference',
    getParentRoute: () => ProtectedOnboardingStepsRouteRoute,
  } as any)
const ProtectedOnboardingStepsFavouriteAgentRouteRoute =
  ProtectedOnboardingStepsFavouriteAgentRouteRouteImport.update({
    id: '/favourite-agent',
    path: '/favourite-agent',
    getParentRoute: () => ProtectedOnboardingStepsRouteRoute,
  } as any)
const ProtectedOnboardingStepsDisplayNameRouteRoute =
  ProtectedOnboardingStepsDisplayNameRouteRouteImport.update({
    id: '/display-name',
    path: '/display-name',
    getParentRoute: () => ProtectedOnboardingStepsRouteRoute,
  } as any)
const ProtectedOnboardingStepsBondingPaceRouteRoute =
  ProtectedOnboardingStepsBondingPaceRouteRouteImport.update({
    id: '/bonding-pace',
    path: '/bonding-pace',
    getParentRoute: () => ProtectedOnboardingStepsRouteRoute,
  } as any)
const ProtectedOnboardingStepsAgeRouteRoute =
  ProtectedOnboardingStepsAgeRouteRouteImport.update({
    id: '/age',
    path: '/age',
    getParentRoute: () => ProtectedOnboardingStepsRouteRoute,
  } as any)
const ProtectedOnboardingStepsSplatRouteRoute =
  ProtectedOnboardingStepsSplatRouteRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => ProtectedOnboardingStepsRouteRoute,
  } as any)
const ProtectedAppMainLayoutFiltersRouteRoute =
  ProtectedAppMainLayoutFiltersRouteRouteImport.update({
    id: '/filters',
    path: '/filters',
    getParentRoute: () => ProtectedAppMainLayoutRouteRoute,
  } as any)
const ProtectedAppMainLayoutDuoChatsRouteRoute =
  ProtectedAppMainLayoutDuoChatsRouteRouteImport.update({
    id: '/duo-chats',
    path: '/duo-chats',
    getParentRoute: () => ProtectedAppMainLayoutRouteRoute,
  } as any)
const ProtectedAppMainLayoutMyDuosIndexRoute =
  ProtectedAppMainLayoutMyDuosIndexRouteImport.update({
    id: '/my-duos/',
    path: '/my-duos/',
    getParentRoute: () => ProtectedAppMainLayoutRouteRoute,
  } as any)
const ProtectedAppMainLayoutMeIndexRoute =
  ProtectedAppMainLayoutMeIndexRouteImport.update({
    id: '/me/',
    path: '/me/',
    getParentRoute: () => ProtectedAppMainLayoutRouteRoute,
  } as any)
const ProtectedAppMainLayoutLikesIndexRoute =
  ProtectedAppMainLayoutLikesIndexRouteImport.update({
    id: '/likes/',
    path: '/likes/',
    getParentRoute: () => ProtectedAppMainLayoutRouteRoute,
  } as any)
const ProtectedAppMainLayoutProfilesMeRouteRoute =
  ProtectedAppMainLayoutProfilesMeRouteRouteImport.update({
    id: '/profiles/me',
    path: '/profiles/me',
    getParentRoute: () => ProtectedAppMainLayoutRouteRoute,
  } as any)
const ProtectedAppMainLayoutProfilesProfileIdRouteRoute =
  ProtectedAppMainLayoutProfilesProfileIdRouteRouteImport.update({
    id: '/profiles/$profileId',
    path: '/profiles/$profileId',
    getParentRoute: () => ProtectedAppMainLayoutRouteRoute,
  } as any)
const ProtectedAppMainLayoutMyDuosIdRouteRoute =
  ProtectedAppMainLayoutMyDuosIdRouteRouteImport.update({
    id: '/my-duos/$id',
    path: '/my-duos/$id',
    getParentRoute: () => ProtectedAppMainLayoutRouteRoute,
  } as any)
const ProtectedAppMainLayoutMeSettingsRouteRoute =
  ProtectedAppMainLayoutMeSettingsRouteRouteImport.update({
    id: '/me/settings',
    path: '/me/settings',
    getParentRoute: () => ProtectedAppMainLayoutRouteRoute,
  } as any)
const ProtectedAppMainLayoutMeEditRouteRoute =
  ProtectedAppMainLayoutMeEditRouteRouteImport.update({
    id: '/me/edit',
    path: '/me/edit',
    getParentRoute: () => ProtectedAppMainLayoutRouteRoute,
  } as any)
const ProtectedAppMainLayoutLikesIdRouteRoute =
  ProtectedAppMainLayoutLikesIdRouteRouteImport.update({
    id: '/likes/$id',
    path: '/likes/$id',
    getParentRoute: () => ProtectedAppMainLayoutRouteRoute,
  } as any)
const ProtectedAppMainLayoutDuoChatsDuoIdRouteRoute =
  ProtectedAppMainLayoutDuoChatsDuoIdRouteRouteImport.update({
    id: '/$duoId',
    path: '/$duoId',
    getParentRoute: () => ProtectedAppMainLayoutDuoChatsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ProtectedAppMainLayoutIndexRoute
  '/child-safety': typeof ChildSafetyRouteRoute
  '/get-app': typeof GetAppRouteRoute
  '/invite': typeof InviteRouteRoute
  '/login': typeof LoginRouteRoute
  '/privacy-policy': typeof PrivacyPolicyRouteRoute
  '/terms': typeof TermsRouteRoute
  '/onboarding': typeof ProtectedOnboardingStepsRouteRouteWithChildren
  '/internal/login': typeof InternalLoginRouteRoute
  '/internal/test-playalert': typeof InternalTestPlayalertRouteRoute
  '/oauth/callback': typeof OauthCallbackRouteRoute
  '/onboarding/': typeof ProtectedOnboardingIndexRoute
  '/duo-chats': typeof ProtectedAppMainLayoutDuoChatsRouteRouteWithChildren
  '/filters': typeof ProtectedAppMainLayoutFiltersRouteRoute
  '/onboarding/$': typeof ProtectedOnboardingStepsSplatRouteRoute
  '/onboarding/age': typeof ProtectedOnboardingStepsAgeRouteRoute
  '/onboarding/bonding-pace': typeof ProtectedOnboardingStepsBondingPaceRouteRoute
  '/onboarding/display-name': typeof ProtectedOnboardingStepsDisplayNameRouteRoute
  '/onboarding/favourite-agent': typeof ProtectedOnboardingStepsFavouriteAgentRouteRoute
  '/onboarding/game-mode-preference': typeof ProtectedOnboardingStepsGameModePreferenceRouteRoute
  '/onboarding/in-game-comm-style': typeof ProtectedOnboardingStepsInGameCommStyleRouteRoute
  '/onboarding/languages': typeof ProtectedOnboardingStepsLanguagesRouteRoute
  '/onboarding/mode-selection': typeof ProtectedOnboardingStepsModeSelectionRouteRoute
  '/onboarding/nearly-done': typeof ProtectedOnboardingStepsNearlyDoneRouteRoute
  '/onboarding/non-toxic': typeof ProtectedOnboardingStepsNonToxicRouteRoute
  '/onboarding/notifications': typeof ProtectedOnboardingStepsNotificationsRouteRoute
  '/onboarding/personality-traits': typeof ProtectedOnboardingStepsPersonalityTraitsRouteRoute
  '/onboarding/play-schedule': typeof ProtectedOnboardingStepsPlayScheduleRouteRoute
  '/onboarding/pre-game-routine': typeof ProtectedOnboardingStepsPreGameRoutineRouteRoute
  '/onboarding/servers': typeof ProtectedOnboardingStepsServersRouteRoute
  '/onboarding/stats': typeof ProtectedOnboardingStepsStatsRouteRoute
  '/onboarding/voice-chat-participation': typeof ProtectedOnboardingStepsVoiceChatParticipationRouteRoute
  '/duo-chats/$duoId': typeof ProtectedAppMainLayoutDuoChatsDuoIdRouteRoute
  '/likes/$id': typeof ProtectedAppMainLayoutLikesIdRouteRoute
  '/me/edit': typeof ProtectedAppMainLayoutMeEditRouteRoute
  '/me/settings': typeof ProtectedAppMainLayoutMeSettingsRouteRoute
  '/my-duos/$id': typeof ProtectedAppMainLayoutMyDuosIdRouteRoute
  '/profiles/$profileId': typeof ProtectedAppMainLayoutProfilesProfileIdRouteRoute
  '/profiles/me': typeof ProtectedAppMainLayoutProfilesMeRouteRoute
  '/likes/': typeof ProtectedAppMainLayoutLikesIndexRoute
  '/me/': typeof ProtectedAppMainLayoutMeIndexRoute
  '/my-duos/': typeof ProtectedAppMainLayoutMyDuosIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof ProtectedAppMainLayoutIndexRoute
  '/child-safety': typeof ChildSafetyRouteRoute
  '/get-app': typeof GetAppRouteRoute
  '/invite': typeof InviteRouteRoute
  '/login': typeof LoginRouteRoute
  '/privacy-policy': typeof PrivacyPolicyRouteRoute
  '/terms': typeof TermsRouteRoute
  '/internal/login': typeof InternalLoginRouteRoute
  '/internal/test-playalert': typeof InternalTestPlayalertRouteRoute
  '/oauth/callback': typeof OauthCallbackRouteRoute
  '/onboarding': typeof ProtectedOnboardingIndexRoute
  '/duo-chats': typeof ProtectedAppMainLayoutDuoChatsRouteRouteWithChildren
  '/filters': typeof ProtectedAppMainLayoutFiltersRouteRoute
  '/onboarding/$': typeof ProtectedOnboardingStepsSplatRouteRoute
  '/onboarding/age': typeof ProtectedOnboardingStepsAgeRouteRoute
  '/onboarding/bonding-pace': typeof ProtectedOnboardingStepsBondingPaceRouteRoute
  '/onboarding/display-name': typeof ProtectedOnboardingStepsDisplayNameRouteRoute
  '/onboarding/favourite-agent': typeof ProtectedOnboardingStepsFavouriteAgentRouteRoute
  '/onboarding/game-mode-preference': typeof ProtectedOnboardingStepsGameModePreferenceRouteRoute
  '/onboarding/in-game-comm-style': typeof ProtectedOnboardingStepsInGameCommStyleRouteRoute
  '/onboarding/languages': typeof ProtectedOnboardingStepsLanguagesRouteRoute
  '/onboarding/mode-selection': typeof ProtectedOnboardingStepsModeSelectionRouteRoute
  '/onboarding/nearly-done': typeof ProtectedOnboardingStepsNearlyDoneRouteRoute
  '/onboarding/non-toxic': typeof ProtectedOnboardingStepsNonToxicRouteRoute
  '/onboarding/notifications': typeof ProtectedOnboardingStepsNotificationsRouteRoute
  '/onboarding/personality-traits': typeof ProtectedOnboardingStepsPersonalityTraitsRouteRoute
  '/onboarding/play-schedule': typeof ProtectedOnboardingStepsPlayScheduleRouteRoute
  '/onboarding/pre-game-routine': typeof ProtectedOnboardingStepsPreGameRoutineRouteRoute
  '/onboarding/servers': typeof ProtectedOnboardingStepsServersRouteRoute
  '/onboarding/stats': typeof ProtectedOnboardingStepsStatsRouteRoute
  '/onboarding/voice-chat-participation': typeof ProtectedOnboardingStepsVoiceChatParticipationRouteRoute
  '/duo-chats/$duoId': typeof ProtectedAppMainLayoutDuoChatsDuoIdRouteRoute
  '/likes/$id': typeof ProtectedAppMainLayoutLikesIdRouteRoute
  '/me/edit': typeof ProtectedAppMainLayoutMeEditRouteRoute
  '/me/settings': typeof ProtectedAppMainLayoutMeSettingsRouteRoute
  '/my-duos/$id': typeof ProtectedAppMainLayoutMyDuosIdRouteRoute
  '/profiles/$profileId': typeof ProtectedAppMainLayoutProfilesProfileIdRouteRoute
  '/profiles/me': typeof ProtectedAppMainLayoutProfilesMeRouteRoute
  '/likes': typeof ProtectedAppMainLayoutLikesIndexRoute
  '/me': typeof ProtectedAppMainLayoutMeIndexRoute
  '/my-duos': typeof ProtectedAppMainLayoutMyDuosIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_protected': typeof ProtectedRouteRouteWithChildren
  '/child-safety': typeof ChildSafetyRouteRoute
  '/get-app': typeof GetAppRouteRoute
  '/invite': typeof InviteRouteRoute
  '/login': typeof LoginRouteRoute
  '/privacy-policy': typeof PrivacyPolicyRouteRoute
  '/terms': typeof TermsRouteRoute
  '/_protected/_app': typeof ProtectedAppRouteRouteWithChildren
  '/_protected/onboarding': typeof ProtectedOnboardingRouteRouteWithChildren
  '/internal/login': typeof InternalLoginRouteRoute
  '/internal/test-playalert': typeof InternalTestPlayalertRouteRoute
  '/oauth/callback': typeof OauthCallbackRouteRoute
  '/_protected/_app/_mainLayout': typeof ProtectedAppMainLayoutRouteRouteWithChildren
  '/_protected/onboarding/_steps': typeof ProtectedOnboardingStepsRouteRouteWithChildren
  '/_protected/onboarding/': typeof ProtectedOnboardingIndexRoute
  '/_protected/_app/_mainLayout/duo-chats': typeof ProtectedAppMainLayoutDuoChatsRouteRouteWithChildren
  '/_protected/_app/_mainLayout/filters': typeof ProtectedAppMainLayoutFiltersRouteRoute
  '/_protected/onboarding/_steps/$': typeof ProtectedOnboardingStepsSplatRouteRoute
  '/_protected/onboarding/_steps/age': typeof ProtectedOnboardingStepsAgeRouteRoute
  '/_protected/onboarding/_steps/bonding-pace': typeof ProtectedOnboardingStepsBondingPaceRouteRoute
  '/_protected/onboarding/_steps/display-name': typeof ProtectedOnboardingStepsDisplayNameRouteRoute
  '/_protected/onboarding/_steps/favourite-agent': typeof ProtectedOnboardingStepsFavouriteAgentRouteRoute
  '/_protected/onboarding/_steps/game-mode-preference': typeof ProtectedOnboardingStepsGameModePreferenceRouteRoute
  '/_protected/onboarding/_steps/in-game-comm-style': typeof ProtectedOnboardingStepsInGameCommStyleRouteRoute
  '/_protected/onboarding/_steps/languages': typeof ProtectedOnboardingStepsLanguagesRouteRoute
  '/_protected/onboarding/_steps/mode-selection': typeof ProtectedOnboardingStepsModeSelectionRouteRoute
  '/_protected/onboarding/_steps/nearly-done': typeof ProtectedOnboardingStepsNearlyDoneRouteRoute
  '/_protected/onboarding/_steps/non-toxic': typeof ProtectedOnboardingStepsNonToxicRouteRoute
  '/_protected/onboarding/_steps/notifications': typeof ProtectedOnboardingStepsNotificationsRouteRoute
  '/_protected/onboarding/_steps/personality-traits': typeof ProtectedOnboardingStepsPersonalityTraitsRouteRoute
  '/_protected/onboarding/_steps/play-schedule': typeof ProtectedOnboardingStepsPlayScheduleRouteRoute
  '/_protected/onboarding/_steps/pre-game-routine': typeof ProtectedOnboardingStepsPreGameRoutineRouteRoute
  '/_protected/onboarding/_steps/servers': typeof ProtectedOnboardingStepsServersRouteRoute
  '/_protected/onboarding/_steps/stats': typeof ProtectedOnboardingStepsStatsRouteRoute
  '/_protected/onboarding/_steps/voice-chat-participation': typeof ProtectedOnboardingStepsVoiceChatParticipationRouteRoute
  '/_protected/_app/_mainLayout/': typeof ProtectedAppMainLayoutIndexRoute
  '/_protected/_app/_mainLayout/duo-chats/$duoId': typeof ProtectedAppMainLayoutDuoChatsDuoIdRouteRoute
  '/_protected/_app/_mainLayout/likes/$id': typeof ProtectedAppMainLayoutLikesIdRouteRoute
  '/_protected/_app/_mainLayout/me/edit': typeof ProtectedAppMainLayoutMeEditRouteRoute
  '/_protected/_app/_mainLayout/me/settings': typeof ProtectedAppMainLayoutMeSettingsRouteRoute
  '/_protected/_app/_mainLayout/my-duos/$id': typeof ProtectedAppMainLayoutMyDuosIdRouteRoute
  '/_protected/_app/_mainLayout/profiles/$profileId': typeof ProtectedAppMainLayoutProfilesProfileIdRouteRoute
  '/_protected/_app/_mainLayout/profiles/me': typeof ProtectedAppMainLayoutProfilesMeRouteRoute
  '/_protected/_app/_mainLayout/likes/': typeof ProtectedAppMainLayoutLikesIndexRoute
  '/_protected/_app/_mainLayout/me/': typeof ProtectedAppMainLayoutMeIndexRoute
  '/_protected/_app/_mainLayout/my-duos/': typeof ProtectedAppMainLayoutMyDuosIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/child-safety'
    | '/get-app'
    | '/invite'
    | '/login'
    | '/privacy-policy'
    | '/terms'
    | '/onboarding'
    | '/internal/login'
    | '/internal/test-playalert'
    | '/oauth/callback'
    | '/onboarding/'
    | '/duo-chats'
    | '/filters'
    | '/onboarding/$'
    | '/onboarding/age'
    | '/onboarding/bonding-pace'
    | '/onboarding/display-name'
    | '/onboarding/favourite-agent'
    | '/onboarding/game-mode-preference'
    | '/onboarding/in-game-comm-style'
    | '/onboarding/languages'
    | '/onboarding/mode-selection'
    | '/onboarding/nearly-done'
    | '/onboarding/non-toxic'
    | '/onboarding/notifications'
    | '/onboarding/personality-traits'
    | '/onboarding/play-schedule'
    | '/onboarding/pre-game-routine'
    | '/onboarding/servers'
    | '/onboarding/stats'
    | '/onboarding/voice-chat-participation'
    | '/duo-chats/$duoId'
    | '/likes/$id'
    | '/me/edit'
    | '/me/settings'
    | '/my-duos/$id'
    | '/profiles/$profileId'
    | '/profiles/me'
    | '/likes/'
    | '/me/'
    | '/my-duos/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/child-safety'
    | '/get-app'
    | '/invite'
    | '/login'
    | '/privacy-policy'
    | '/terms'
    | '/internal/login'
    | '/internal/test-playalert'
    | '/oauth/callback'
    | '/onboarding'
    | '/duo-chats'
    | '/filters'
    | '/onboarding/$'
    | '/onboarding/age'
    | '/onboarding/bonding-pace'
    | '/onboarding/display-name'
    | '/onboarding/favourite-agent'
    | '/onboarding/game-mode-preference'
    | '/onboarding/in-game-comm-style'
    | '/onboarding/languages'
    | '/onboarding/mode-selection'
    | '/onboarding/nearly-done'
    | '/onboarding/non-toxic'
    | '/onboarding/notifications'
    | '/onboarding/personality-traits'
    | '/onboarding/play-schedule'
    | '/onboarding/pre-game-routine'
    | '/onboarding/servers'
    | '/onboarding/stats'
    | '/onboarding/voice-chat-participation'
    | '/duo-chats/$duoId'
    | '/likes/$id'
    | '/me/edit'
    | '/me/settings'
    | '/my-duos/$id'
    | '/profiles/$profileId'
    | '/profiles/me'
    | '/likes'
    | '/me'
    | '/my-duos'
  id:
    | '__root__'
    | '/_protected'
    | '/child-safety'
    | '/get-app'
    | '/invite'
    | '/login'
    | '/privacy-policy'
    | '/terms'
    | '/_protected/_app'
    | '/_protected/onboarding'
    | '/internal/login'
    | '/internal/test-playalert'
    | '/oauth/callback'
    | '/_protected/_app/_mainLayout'
    | '/_protected/onboarding/_steps'
    | '/_protected/onboarding/'
    | '/_protected/_app/_mainLayout/duo-chats'
    | '/_protected/_app/_mainLayout/filters'
    | '/_protected/onboarding/_steps/$'
    | '/_protected/onboarding/_steps/age'
    | '/_protected/onboarding/_steps/bonding-pace'
    | '/_protected/onboarding/_steps/display-name'
    | '/_protected/onboarding/_steps/favourite-agent'
    | '/_protected/onboarding/_steps/game-mode-preference'
    | '/_protected/onboarding/_steps/in-game-comm-style'
    | '/_protected/onboarding/_steps/languages'
    | '/_protected/onboarding/_steps/mode-selection'
    | '/_protected/onboarding/_steps/nearly-done'
    | '/_protected/onboarding/_steps/non-toxic'
    | '/_protected/onboarding/_steps/notifications'
    | '/_protected/onboarding/_steps/personality-traits'
    | '/_protected/onboarding/_steps/play-schedule'
    | '/_protected/onboarding/_steps/pre-game-routine'
    | '/_protected/onboarding/_steps/servers'
    | '/_protected/onboarding/_steps/stats'
    | '/_protected/onboarding/_steps/voice-chat-participation'
    | '/_protected/_app/_mainLayout/'
    | '/_protected/_app/_mainLayout/duo-chats/$duoId'
    | '/_protected/_app/_mainLayout/likes/$id'
    | '/_protected/_app/_mainLayout/me/edit'
    | '/_protected/_app/_mainLayout/me/settings'
    | '/_protected/_app/_mainLayout/my-duos/$id'
    | '/_protected/_app/_mainLayout/profiles/$profileId'
    | '/_protected/_app/_mainLayout/profiles/me'
    | '/_protected/_app/_mainLayout/likes/'
    | '/_protected/_app/_mainLayout/me/'
    | '/_protected/_app/_mainLayout/my-duos/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ProtectedRouteRoute: typeof ProtectedRouteRouteWithChildren
  ChildSafetyRouteRoute: typeof ChildSafetyRouteRoute
  GetAppRouteRoute: typeof GetAppRouteRoute
  InviteRouteRoute: typeof InviteRouteRoute
  LoginRouteRoute: typeof LoginRouteRoute
  PrivacyPolicyRouteRoute: typeof PrivacyPolicyRouteRoute
  TermsRouteRoute: typeof TermsRouteRoute
  InternalLoginRouteRoute: typeof InternalLoginRouteRoute
  InternalTestPlayalertRouteRoute: typeof InternalTestPlayalertRouteRoute
  OauthCallbackRouteRoute: typeof OauthCallbackRouteRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/get-app': {
      id: '/get-app'
      path: '/get-app'
      fullPath: '/get-app'
      preLoaderRoute: typeof GetAppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/child-safety': {
      id: '/child-safety'
      path: '/child-safety'
      fullPath: '/child-safety'
      preLoaderRoute: typeof ChildSafetyRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/callback': {
      id: '/oauth/callback'
      path: '/oauth/callback'
      fullPath: '/oauth/callback'
      preLoaderRoute: typeof OauthCallbackRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/internal/test-playalert': {
      id: '/internal/test-playalert'
      path: '/internal/test-playalert'
      fullPath: '/internal/test-playalert'
      preLoaderRoute: typeof InternalTestPlayalertRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/internal/login': {
      id: '/internal/login'
      path: '/internal/login'
      fullPath: '/internal/login'
      preLoaderRoute: typeof InternalLoginRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/onboarding': {
      id: '/_protected/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof ProtectedOnboardingRouteRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/_app': {
      id: '/_protected/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedAppRouteRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/onboarding/': {
      id: '/_protected/onboarding/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof ProtectedOnboardingIndexRouteImport
      parentRoute: typeof ProtectedOnboardingRouteRoute
    }
    '/_protected/onboarding/_steps': {
      id: '/_protected/onboarding/_steps'
      path: ''
      fullPath: '/onboarding'
      preLoaderRoute: typeof ProtectedOnboardingStepsRouteRouteImport
      parentRoute: typeof ProtectedOnboardingRouteRoute
    }
    '/_protected/_app/_mainLayout': {
      id: '/_protected/_app/_mainLayout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedAppMainLayoutRouteRouteImport
      parentRoute: typeof ProtectedAppRouteRoute
    }
    '/_protected/_app/_mainLayout/': {
      id: '/_protected/_app/_mainLayout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ProtectedAppMainLayoutIndexRouteImport
      parentRoute: typeof ProtectedAppMainLayoutRouteRoute
    }
    '/_protected/onboarding/_steps/voice-chat-participation': {
      id: '/_protected/onboarding/_steps/voice-chat-participation'
      path: '/voice-chat-participation'
      fullPath: '/onboarding/voice-chat-participation'
      preLoaderRoute: typeof ProtectedOnboardingStepsVoiceChatParticipationRouteRouteImport
      parentRoute: typeof ProtectedOnboardingStepsRouteRoute
    }
    '/_protected/onboarding/_steps/stats': {
      id: '/_protected/onboarding/_steps/stats'
      path: '/stats'
      fullPath: '/onboarding/stats'
      preLoaderRoute: typeof ProtectedOnboardingStepsStatsRouteRouteImport
      parentRoute: typeof ProtectedOnboardingStepsRouteRoute
    }
    '/_protected/onboarding/_steps/servers': {
      id: '/_protected/onboarding/_steps/servers'
      path: '/servers'
      fullPath: '/onboarding/servers'
      preLoaderRoute: typeof ProtectedOnboardingStepsServersRouteRouteImport
      parentRoute: typeof ProtectedOnboardingStepsRouteRoute
    }
    '/_protected/onboarding/_steps/pre-game-routine': {
      id: '/_protected/onboarding/_steps/pre-game-routine'
      path: '/pre-game-routine'
      fullPath: '/onboarding/pre-game-routine'
      preLoaderRoute: typeof ProtectedOnboardingStepsPreGameRoutineRouteRouteImport
      parentRoute: typeof ProtectedOnboardingStepsRouteRoute
    }
    '/_protected/onboarding/_steps/play-schedule': {
      id: '/_protected/onboarding/_steps/play-schedule'
      path: '/play-schedule'
      fullPath: '/onboarding/play-schedule'
      preLoaderRoute: typeof ProtectedOnboardingStepsPlayScheduleRouteRouteImport
      parentRoute: typeof ProtectedOnboardingStepsRouteRoute
    }
    '/_protected/onboarding/_steps/personality-traits': {
      id: '/_protected/onboarding/_steps/personality-traits'
      path: '/personality-traits'
      fullPath: '/onboarding/personality-traits'
      preLoaderRoute: typeof ProtectedOnboardingStepsPersonalityTraitsRouteRouteImport
      parentRoute: typeof ProtectedOnboardingStepsRouteRoute
    }
    '/_protected/onboarding/_steps/notifications': {
      id: '/_protected/onboarding/_steps/notifications'
      path: '/notifications'
      fullPath: '/onboarding/notifications'
      preLoaderRoute: typeof ProtectedOnboardingStepsNotificationsRouteRouteImport
      parentRoute: typeof ProtectedOnboardingStepsRouteRoute
    }
    '/_protected/onboarding/_steps/non-toxic': {
      id: '/_protected/onboarding/_steps/non-toxic'
      path: '/non-toxic'
      fullPath: '/onboarding/non-toxic'
      preLoaderRoute: typeof ProtectedOnboardingStepsNonToxicRouteRouteImport
      parentRoute: typeof ProtectedOnboardingStepsRouteRoute
    }
    '/_protected/onboarding/_steps/nearly-done': {
      id: '/_protected/onboarding/_steps/nearly-done'
      path: '/nearly-done'
      fullPath: '/onboarding/nearly-done'
      preLoaderRoute: typeof ProtectedOnboardingStepsNearlyDoneRouteRouteImport
      parentRoute: typeof ProtectedOnboardingStepsRouteRoute
    }
    '/_protected/onboarding/_steps/mode-selection': {
      id: '/_protected/onboarding/_steps/mode-selection'
      path: '/mode-selection'
      fullPath: '/onboarding/mode-selection'
      preLoaderRoute: typeof ProtectedOnboardingStepsModeSelectionRouteRouteImport
      parentRoute: typeof ProtectedOnboardingStepsRouteRoute
    }
    '/_protected/onboarding/_steps/languages': {
      id: '/_protected/onboarding/_steps/languages'
      path: '/languages'
      fullPath: '/onboarding/languages'
      preLoaderRoute: typeof ProtectedOnboardingStepsLanguagesRouteRouteImport
      parentRoute: typeof ProtectedOnboardingStepsRouteRoute
    }
    '/_protected/onboarding/_steps/in-game-comm-style': {
      id: '/_protected/onboarding/_steps/in-game-comm-style'
      path: '/in-game-comm-style'
      fullPath: '/onboarding/in-game-comm-style'
      preLoaderRoute: typeof ProtectedOnboardingStepsInGameCommStyleRouteRouteImport
      parentRoute: typeof ProtectedOnboardingStepsRouteRoute
    }
    '/_protected/onboarding/_steps/game-mode-preference': {
      id: '/_protected/onboarding/_steps/game-mode-preference'
      path: '/game-mode-preference'
      fullPath: '/onboarding/game-mode-preference'
      preLoaderRoute: typeof ProtectedOnboardingStepsGameModePreferenceRouteRouteImport
      parentRoute: typeof ProtectedOnboardingStepsRouteRoute
    }
    '/_protected/onboarding/_steps/favourite-agent': {
      id: '/_protected/onboarding/_steps/favourite-agent'
      path: '/favourite-agent'
      fullPath: '/onboarding/favourite-agent'
      preLoaderRoute: typeof ProtectedOnboardingStepsFavouriteAgentRouteRouteImport
      parentRoute: typeof ProtectedOnboardingStepsRouteRoute
    }
    '/_protected/onboarding/_steps/display-name': {
      id: '/_protected/onboarding/_steps/display-name'
      path: '/display-name'
      fullPath: '/onboarding/display-name'
      preLoaderRoute: typeof ProtectedOnboardingStepsDisplayNameRouteRouteImport
      parentRoute: typeof ProtectedOnboardingStepsRouteRoute
    }
    '/_protected/onboarding/_steps/bonding-pace': {
      id: '/_protected/onboarding/_steps/bonding-pace'
      path: '/bonding-pace'
      fullPath: '/onboarding/bonding-pace'
      preLoaderRoute: typeof ProtectedOnboardingStepsBondingPaceRouteRouteImport
      parentRoute: typeof ProtectedOnboardingStepsRouteRoute
    }
    '/_protected/onboarding/_steps/age': {
      id: '/_protected/onboarding/_steps/age'
      path: '/age'
      fullPath: '/onboarding/age'
      preLoaderRoute: typeof ProtectedOnboardingStepsAgeRouteRouteImport
      parentRoute: typeof ProtectedOnboardingStepsRouteRoute
    }
    '/_protected/onboarding/_steps/$': {
      id: '/_protected/onboarding/_steps/$'
      path: '/$'
      fullPath: '/onboarding/$'
      preLoaderRoute: typeof ProtectedOnboardingStepsSplatRouteRouteImport
      parentRoute: typeof ProtectedOnboardingStepsRouteRoute
    }
    '/_protected/_app/_mainLayout/filters': {
      id: '/_protected/_app/_mainLayout/filters'
      path: '/filters'
      fullPath: '/filters'
      preLoaderRoute: typeof ProtectedAppMainLayoutFiltersRouteRouteImport
      parentRoute: typeof ProtectedAppMainLayoutRouteRoute
    }
    '/_protected/_app/_mainLayout/duo-chats': {
      id: '/_protected/_app/_mainLayout/duo-chats'
      path: '/duo-chats'
      fullPath: '/duo-chats'
      preLoaderRoute: typeof ProtectedAppMainLayoutDuoChatsRouteRouteImport
      parentRoute: typeof ProtectedAppMainLayoutRouteRoute
    }
    '/_protected/_app/_mainLayout/my-duos/': {
      id: '/_protected/_app/_mainLayout/my-duos/'
      path: '/my-duos'
      fullPath: '/my-duos/'
      preLoaderRoute: typeof ProtectedAppMainLayoutMyDuosIndexRouteImport
      parentRoute: typeof ProtectedAppMainLayoutRouteRoute
    }
    '/_protected/_app/_mainLayout/me/': {
      id: '/_protected/_app/_mainLayout/me/'
      path: '/me'
      fullPath: '/me/'
      preLoaderRoute: typeof ProtectedAppMainLayoutMeIndexRouteImport
      parentRoute: typeof ProtectedAppMainLayoutRouteRoute
    }
    '/_protected/_app/_mainLayout/likes/': {
      id: '/_protected/_app/_mainLayout/likes/'
      path: '/likes'
      fullPath: '/likes/'
      preLoaderRoute: typeof ProtectedAppMainLayoutLikesIndexRouteImport
      parentRoute: typeof ProtectedAppMainLayoutRouteRoute
    }
    '/_protected/_app/_mainLayout/profiles/me': {
      id: '/_protected/_app/_mainLayout/profiles/me'
      path: '/profiles/me'
      fullPath: '/profiles/me'
      preLoaderRoute: typeof ProtectedAppMainLayoutProfilesMeRouteRouteImport
      parentRoute: typeof ProtectedAppMainLayoutRouteRoute
    }
    '/_protected/_app/_mainLayout/profiles/$profileId': {
      id: '/_protected/_app/_mainLayout/profiles/$profileId'
      path: '/profiles/$profileId'
      fullPath: '/profiles/$profileId'
      preLoaderRoute: typeof ProtectedAppMainLayoutProfilesProfileIdRouteRouteImport
      parentRoute: typeof ProtectedAppMainLayoutRouteRoute
    }
    '/_protected/_app/_mainLayout/my-duos/$id': {
      id: '/_protected/_app/_mainLayout/my-duos/$id'
      path: '/my-duos/$id'
      fullPath: '/my-duos/$id'
      preLoaderRoute: typeof ProtectedAppMainLayoutMyDuosIdRouteRouteImport
      parentRoute: typeof ProtectedAppMainLayoutRouteRoute
    }
    '/_protected/_app/_mainLayout/me/settings': {
      id: '/_protected/_app/_mainLayout/me/settings'
      path: '/me/settings'
      fullPath: '/me/settings'
      preLoaderRoute: typeof ProtectedAppMainLayoutMeSettingsRouteRouteImport
      parentRoute: typeof ProtectedAppMainLayoutRouteRoute
    }
    '/_protected/_app/_mainLayout/me/edit': {
      id: '/_protected/_app/_mainLayout/me/edit'
      path: '/me/edit'
      fullPath: '/me/edit'
      preLoaderRoute: typeof ProtectedAppMainLayoutMeEditRouteRouteImport
      parentRoute: typeof ProtectedAppMainLayoutRouteRoute
    }
    '/_protected/_app/_mainLayout/likes/$id': {
      id: '/_protected/_app/_mainLayout/likes/$id'
      path: '/likes/$id'
      fullPath: '/likes/$id'
      preLoaderRoute: typeof ProtectedAppMainLayoutLikesIdRouteRouteImport
      parentRoute: typeof ProtectedAppMainLayoutRouteRoute
    }
    '/_protected/_app/_mainLayout/duo-chats/$duoId': {
      id: '/_protected/_app/_mainLayout/duo-chats/$duoId'
      path: '/$duoId'
      fullPath: '/duo-chats/$duoId'
      preLoaderRoute: typeof ProtectedAppMainLayoutDuoChatsDuoIdRouteRouteImport
      parentRoute: typeof ProtectedAppMainLayoutDuoChatsRouteRoute
    }
  }
}

interface ProtectedAppMainLayoutDuoChatsRouteRouteChildren {
  ProtectedAppMainLayoutDuoChatsDuoIdRouteRoute: typeof ProtectedAppMainLayoutDuoChatsDuoIdRouteRoute
}

const ProtectedAppMainLayoutDuoChatsRouteRouteChildren: ProtectedAppMainLayoutDuoChatsRouteRouteChildren =
  {
    ProtectedAppMainLayoutDuoChatsDuoIdRouteRoute:
      ProtectedAppMainLayoutDuoChatsDuoIdRouteRoute,
  }

const ProtectedAppMainLayoutDuoChatsRouteRouteWithChildren =
  ProtectedAppMainLayoutDuoChatsRouteRoute._addFileChildren(
    ProtectedAppMainLayoutDuoChatsRouteRouteChildren,
  )

interface ProtectedAppMainLayoutRouteRouteChildren {
  ProtectedAppMainLayoutDuoChatsRouteRoute: typeof ProtectedAppMainLayoutDuoChatsRouteRouteWithChildren
  ProtectedAppMainLayoutFiltersRouteRoute: typeof ProtectedAppMainLayoutFiltersRouteRoute
  ProtectedAppMainLayoutIndexRoute: typeof ProtectedAppMainLayoutIndexRoute
  ProtectedAppMainLayoutLikesIdRouteRoute: typeof ProtectedAppMainLayoutLikesIdRouteRoute
  ProtectedAppMainLayoutMeEditRouteRoute: typeof ProtectedAppMainLayoutMeEditRouteRoute
  ProtectedAppMainLayoutMeSettingsRouteRoute: typeof ProtectedAppMainLayoutMeSettingsRouteRoute
  ProtectedAppMainLayoutMyDuosIdRouteRoute: typeof ProtectedAppMainLayoutMyDuosIdRouteRoute
  ProtectedAppMainLayoutProfilesProfileIdRouteRoute: typeof ProtectedAppMainLayoutProfilesProfileIdRouteRoute
  ProtectedAppMainLayoutProfilesMeRouteRoute: typeof ProtectedAppMainLayoutProfilesMeRouteRoute
  ProtectedAppMainLayoutLikesIndexRoute: typeof ProtectedAppMainLayoutLikesIndexRoute
  ProtectedAppMainLayoutMeIndexRoute: typeof ProtectedAppMainLayoutMeIndexRoute
  ProtectedAppMainLayoutMyDuosIndexRoute: typeof ProtectedAppMainLayoutMyDuosIndexRoute
}

const ProtectedAppMainLayoutRouteRouteChildren: ProtectedAppMainLayoutRouteRouteChildren =
  {
    ProtectedAppMainLayoutDuoChatsRouteRoute:
      ProtectedAppMainLayoutDuoChatsRouteRouteWithChildren,
    ProtectedAppMainLayoutFiltersRouteRoute:
      ProtectedAppMainLayoutFiltersRouteRoute,
    ProtectedAppMainLayoutIndexRoute: ProtectedAppMainLayoutIndexRoute,
    ProtectedAppMainLayoutLikesIdRouteRoute:
      ProtectedAppMainLayoutLikesIdRouteRoute,
    ProtectedAppMainLayoutMeEditRouteRoute:
      ProtectedAppMainLayoutMeEditRouteRoute,
    ProtectedAppMainLayoutMeSettingsRouteRoute:
      ProtectedAppMainLayoutMeSettingsRouteRoute,
    ProtectedAppMainLayoutMyDuosIdRouteRoute:
      ProtectedAppMainLayoutMyDuosIdRouteRoute,
    ProtectedAppMainLayoutProfilesProfileIdRouteRoute:
      ProtectedAppMainLayoutProfilesProfileIdRouteRoute,
    ProtectedAppMainLayoutProfilesMeRouteRoute:
      ProtectedAppMainLayoutProfilesMeRouteRoute,
    ProtectedAppMainLayoutLikesIndexRoute:
      ProtectedAppMainLayoutLikesIndexRoute,
    ProtectedAppMainLayoutMeIndexRoute: ProtectedAppMainLayoutMeIndexRoute,
    ProtectedAppMainLayoutMyDuosIndexRoute:
      ProtectedAppMainLayoutMyDuosIndexRoute,
  }

const ProtectedAppMainLayoutRouteRouteWithChildren =
  ProtectedAppMainLayoutRouteRoute._addFileChildren(
    ProtectedAppMainLayoutRouteRouteChildren,
  )

interface ProtectedAppRouteRouteChildren {
  ProtectedAppMainLayoutRouteRoute: typeof ProtectedAppMainLayoutRouteRouteWithChildren
}

const ProtectedAppRouteRouteChildren: ProtectedAppRouteRouteChildren = {
  ProtectedAppMainLayoutRouteRoute:
    ProtectedAppMainLayoutRouteRouteWithChildren,
}

const ProtectedAppRouteRouteWithChildren =
  ProtectedAppRouteRoute._addFileChildren(ProtectedAppRouteRouteChildren)

interface ProtectedOnboardingStepsRouteRouteChildren {
  ProtectedOnboardingStepsSplatRouteRoute: typeof ProtectedOnboardingStepsSplatRouteRoute
  ProtectedOnboardingStepsAgeRouteRoute: typeof ProtectedOnboardingStepsAgeRouteRoute
  ProtectedOnboardingStepsBondingPaceRouteRoute: typeof ProtectedOnboardingStepsBondingPaceRouteRoute
  ProtectedOnboardingStepsDisplayNameRouteRoute: typeof ProtectedOnboardingStepsDisplayNameRouteRoute
  ProtectedOnboardingStepsFavouriteAgentRouteRoute: typeof ProtectedOnboardingStepsFavouriteAgentRouteRoute
  ProtectedOnboardingStepsGameModePreferenceRouteRoute: typeof ProtectedOnboardingStepsGameModePreferenceRouteRoute
  ProtectedOnboardingStepsInGameCommStyleRouteRoute: typeof ProtectedOnboardingStepsInGameCommStyleRouteRoute
  ProtectedOnboardingStepsLanguagesRouteRoute: typeof ProtectedOnboardingStepsLanguagesRouteRoute
  ProtectedOnboardingStepsModeSelectionRouteRoute: typeof ProtectedOnboardingStepsModeSelectionRouteRoute
  ProtectedOnboardingStepsNearlyDoneRouteRoute: typeof ProtectedOnboardingStepsNearlyDoneRouteRoute
  ProtectedOnboardingStepsNonToxicRouteRoute: typeof ProtectedOnboardingStepsNonToxicRouteRoute
  ProtectedOnboardingStepsNotificationsRouteRoute: typeof ProtectedOnboardingStepsNotificationsRouteRoute
  ProtectedOnboardingStepsPersonalityTraitsRouteRoute: typeof ProtectedOnboardingStepsPersonalityTraitsRouteRoute
  ProtectedOnboardingStepsPlayScheduleRouteRoute: typeof ProtectedOnboardingStepsPlayScheduleRouteRoute
  ProtectedOnboardingStepsPreGameRoutineRouteRoute: typeof ProtectedOnboardingStepsPreGameRoutineRouteRoute
  ProtectedOnboardingStepsServersRouteRoute: typeof ProtectedOnboardingStepsServersRouteRoute
  ProtectedOnboardingStepsStatsRouteRoute: typeof ProtectedOnboardingStepsStatsRouteRoute
  ProtectedOnboardingStepsVoiceChatParticipationRouteRoute: typeof ProtectedOnboardingStepsVoiceChatParticipationRouteRoute
}

const ProtectedOnboardingStepsRouteRouteChildren: ProtectedOnboardingStepsRouteRouteChildren =
  {
    ProtectedOnboardingStepsSplatRouteRoute:
      ProtectedOnboardingStepsSplatRouteRoute,
    ProtectedOnboardingStepsAgeRouteRoute:
      ProtectedOnboardingStepsAgeRouteRoute,
    ProtectedOnboardingStepsBondingPaceRouteRoute:
      ProtectedOnboardingStepsBondingPaceRouteRoute,
    ProtectedOnboardingStepsDisplayNameRouteRoute:
      ProtectedOnboardingStepsDisplayNameRouteRoute,
    ProtectedOnboardingStepsFavouriteAgentRouteRoute:
      ProtectedOnboardingStepsFavouriteAgentRouteRoute,
    ProtectedOnboardingStepsGameModePreferenceRouteRoute:
      ProtectedOnboardingStepsGameModePreferenceRouteRoute,
    ProtectedOnboardingStepsInGameCommStyleRouteRoute:
      ProtectedOnboardingStepsInGameCommStyleRouteRoute,
    ProtectedOnboardingStepsLanguagesRouteRoute:
      ProtectedOnboardingStepsLanguagesRouteRoute,
    ProtectedOnboardingStepsModeSelectionRouteRoute:
      ProtectedOnboardingStepsModeSelectionRouteRoute,
    ProtectedOnboardingStepsNearlyDoneRouteRoute:
      ProtectedOnboardingStepsNearlyDoneRouteRoute,
    ProtectedOnboardingStepsNonToxicRouteRoute:
      ProtectedOnboardingStepsNonToxicRouteRoute,
    ProtectedOnboardingStepsNotificationsRouteRoute:
      ProtectedOnboardingStepsNotificationsRouteRoute,
    ProtectedOnboardingStepsPersonalityTraitsRouteRoute:
      ProtectedOnboardingStepsPersonalityTraitsRouteRoute,
    ProtectedOnboardingStepsPlayScheduleRouteRoute:
      ProtectedOnboardingStepsPlayScheduleRouteRoute,
    ProtectedOnboardingStepsPreGameRoutineRouteRoute:
      ProtectedOnboardingStepsPreGameRoutineRouteRoute,
    ProtectedOnboardingStepsServersRouteRoute:
      ProtectedOnboardingStepsServersRouteRoute,
    ProtectedOnboardingStepsStatsRouteRoute:
      ProtectedOnboardingStepsStatsRouteRoute,
    ProtectedOnboardingStepsVoiceChatParticipationRouteRoute:
      ProtectedOnboardingStepsVoiceChatParticipationRouteRoute,
  }

const ProtectedOnboardingStepsRouteRouteWithChildren =
  ProtectedOnboardingStepsRouteRoute._addFileChildren(
    ProtectedOnboardingStepsRouteRouteChildren,
  )

interface ProtectedOnboardingRouteRouteChildren {
  ProtectedOnboardingStepsRouteRoute: typeof ProtectedOnboardingStepsRouteRouteWithChildren
  ProtectedOnboardingIndexRoute: typeof ProtectedOnboardingIndexRoute
}

const ProtectedOnboardingRouteRouteChildren: ProtectedOnboardingRouteRouteChildren =
  {
    ProtectedOnboardingStepsRouteRoute:
      ProtectedOnboardingStepsRouteRouteWithChildren,
    ProtectedOnboardingIndexRoute: ProtectedOnboardingIndexRoute,
  }

const ProtectedOnboardingRouteRouteWithChildren =
  ProtectedOnboardingRouteRoute._addFileChildren(
    ProtectedOnboardingRouteRouteChildren,
  )

interface ProtectedRouteRouteChildren {
  ProtectedAppRouteRoute: typeof ProtectedAppRouteRouteWithChildren
  ProtectedOnboardingRouteRoute: typeof ProtectedOnboardingRouteRouteWithChildren
}

const ProtectedRouteRouteChildren: ProtectedRouteRouteChildren = {
  ProtectedAppRouteRoute: ProtectedAppRouteRouteWithChildren,
  ProtectedOnboardingRouteRoute: ProtectedOnboardingRouteRouteWithChildren,
}

const ProtectedRouteRouteWithChildren = ProtectedRouteRoute._addFileChildren(
  ProtectedRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  ProtectedRouteRoute: ProtectedRouteRouteWithChildren,
  ChildSafetyRouteRoute: ChildSafetyRouteRoute,
  GetAppRouteRoute: GetAppRouteRoute,
  InviteRouteRoute: InviteRouteRoute,
  LoginRouteRoute: LoginRouteRoute,
  PrivacyPolicyRouteRoute: PrivacyPolicyRouteRoute,
  TermsRouteRoute: TermsRouteRoute,
  InternalLoginRouteRoute: InternalLoginRouteRoute,
  InternalTestPlayalertRouteRoute: InternalTestPlayalertRouteRoute,
  OauthCallbackRouteRoute: OauthCallbackRouteRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
